import { z } from 'zod';
import { CostNegotiationMode } from '../../../../../IPA/Negociacoes/pages/NegociacaoFornecedor/costNegotiation';

export const setupBasicConfigSchema = z.object({
  id: z.string().optional(),
  pricing_preferences: z.enum(['STORE', 'CLUSTER']),
  cost_field: z.string(),
  adjustemend_price_mode: z.enum(['NEW', 'OLD']).optional(),
});

export const setupBasicConfigResponseSchema = setupBasicConfigSchema.extend({
  negotiation_cost: z.nativeEnum(CostNegotiationMode).nullable(),
});

export type SetupBasicConfigSchema = z.infer<typeof setupBasicConfigSchema>;
export type SetupBasicConfigResponseSchema = z.infer<typeof setupBasicConfigResponseSchema>;
